import { useCallback } from "react";
import { useAuth } from "@clerk/react";
import { http } from "@/lib/api";

export const useAdminApi = () => {
  const { getToken } = useAuth();
  return useCallback(
    async (method, url, data, opts = {}) => {
      const token = await getToken();
      const res = await http.request({ method, url, data, headers: { Authorization: `Bearer ${token}` }, ...opts });
      return res.data;
    },
    [getToken]
  );
};

export const downloadCsv = async (api, what) => {
  const blob = await api("get", `/admin/export/${what}`, null, { responseType: "blob" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${what}-report.csv`;
  a.click();
  URL.revokeObjectURL(url);
};
